var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProductTrial = function SvgProductTrial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 1.46484L21.875 6.54297V19.2383L11.7188 24.3042L1.5625 19.2383V6.54297L11.7188 1.46484ZM19.3481 7.03125L11.7188 3.22266L8.77686 4.6875L16.3574 8.52051L19.3481 7.03125ZM11.7188 10.8398L14.624 9.39941L7.03125 5.56641L4.08936 7.03125L11.7188 10.8398ZM3.125 8.30078V18.2617L10.9375 22.168V12.207L3.125 8.30078ZM12.5 22.168L20.3125 18.2617V8.30078L12.5 12.207V22.168Z",
    fill: "currentColor"
  })));
};
export default SvgProductTrial;